import * as React from 'react'
import RequestParameters from "./requestParameters";
import {useTranslation} from "gatsby-plugin-react-i18next";
import EnumParameter from "./enumParameter";

const MergeOptions = (props) => {
    const {t} = useTranslation();
    const [masterFile, setMasterFile] = React.useState("");
    const [excludeMasterFile, setExcludeMasterFile] = React.useState(false);


    React.useEffect(() => {
        if (props.disable)
            return;
        const options = [];
        masterFile !== null && masterFile !== "" && options.push({key: "masterFileName", value: `"${masterFile}"`});
        excludeMasterFile && options.push({key: "excludeMasterFile", value: excludeMasterFile});
        props.onChange(options)
    }, [masterFile, excludeMasterFile])
    

    return (
        <RequestParameters disable={props.disable}>
            <EnumParameter
                values={props.files?.map(f => f.name)}
                type="string"
                parameter="masterFileName"
                description={t("merge-master-file-name")}
                onChange={(e) => {
                    setMasterFile(e.target.value);
                }}
                disable={props.disable}/>
            <EnumParameter
                values={["false", "true"]}
                type="bool"
                parameter="excludeMasterFile"
                description={t("merge-exclude-mater-file")}
                onChange={(e) => {
                    setExcludeMasterFile(e.target.value === "true");
                }}
                disable={props.disable}/>
        </RequestParameters>
    );
}

export default MergeOptions;